import i18n, { initI18n, setLocale } from '@link/share/i18n';
import shareLangEn from '@link/share/i18n/lang/en';
import shareLangJa from '@link/share/i18n/lang/ja';
import shareLangKo from '@link/share/i18n/lang/ko';
import shareLangZh from '@link/share/i18n/lang/zh';
import shareLangZt from '@link/share/i18n/lang/zt';
import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';
import overrides from './overrides';

initI18n({
  overrides,
  enText: {
    views: {
      terms: shareLangEn.terms,
      booking: shareLangEn.booking,
      bookResult: shareLangEn.bookResult,
      ...en.views,
      faq: { ...shareLangEn.faq, ...en.views.faq }
    }
  },
  jaText: {
    views: {
      terms: shareLangJa.terms,
      booking: shareLangJa.booking,
      bookResult: shareLangJa.bookResult,
      ...ja.views,
      faq: { ...shareLangJa.faq, ...ja.views.faq }
    }
  },
  koText: {
    views: {
      terms: shareLangKo.terms,
      booking: shareLangKo.booking,
      bookResult: shareLangKo.bookResult,
      ...ko.views,
      faq: { ...shareLangKo.faq, ...ko.views.faq }
    }
  },
  zhText: {
    views: {
      terms: shareLangZh.terms,
      booking: shareLangZh.booking,
      bookResult: shareLangZh.bookResult,
      ...zh.views,
      faq: { ...shareLangZh.faq, ...zh.views.faq }
    }
  },
  ztText: {
    views: {
      terms: shareLangZt.terms,
      booking: shareLangZt.booking,
      bookResult: shareLangZt.bookResult,
      ...zt.views,
      faq: { ...shareLangZt.faq, ...zt.views.faq }
    }
  }
});

export { setLocale };

export default i18n;
